import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: 'KanitGa, sans-serif',
    body: 'DbPenthaiX, sans-serif',
  },
  colors: {
    brand: {
      50: '#FEF2F2',
      100: '#FEE2E2',
      200: '#FECACA',
      300: '#FCA5A5',
      400: '#F87171',
      500: '#F45354', // Primary: Sunset Orange
      600: '#DC2626',
      700: '#B91C1C',
      800: '#991B1B',
      900: '#7F1D1D',
    },
    neutral: {
      50: '#F7F4F4', // Accent/Background: Cultured
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      900: '#242424', // Secondary: Raisin Black
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'normal',
        borderRadius: 'md',
        _focus: {
          boxShadow: 'outline',
        },
      },
      variants: {
        solid: {
          bg: 'brand.500',
          color: 'white',
          _hover: {
            bg: 'brand.600',
          },
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.500',
          _hover: {
            bg: 'brand.500',
            color: 'white',
          },
        },
      },
    },
    Link: {
      baseStyle: {
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        fontFamily: 'DbPenthaiX, sans-serif',
        color: 'neutral.900',
        bg: 'white',
      },
      h1: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
      h2: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
      h3: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
      h4: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
      h5: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
      h6: {
        fontFamily: 'KanitGa, sans-serif',
        fontWeight: 'normal',
      },
    },
  },
});

export default theme; 